import React from 'react';

import CaregiverListScene from '../../list/CaregiverListScene';

import {generateLoomFilterOptions} from './LoomFilterGenerator';

import backend from 'utils/backend';

const filterOptions = generateLoomFilterOptions();
const formatLanguageFilter = (labels) => labels;

const LoomCaregiverList = (props) => {
  return (
    <CaregiverListScene
      {...props}
      caregiverApi={backend.loom.caregiver}
      caregiverDetailBasePath='/caregiver-loom'
      filterOptions={filterOptions}
      formatLanguageFilter={formatLanguageFilter}
      showMapFilter={false}
      statusTranslationKey='caregiver.LoomStatus'
      titleExpression='caregiver.CaregiverList.LoomTitle'
    />
  );
};

export default React.memo(LoomCaregiverList);
